import {
    EntityType,
    ProgressMessage,
    SlackNotificationSettings,
    SlackNotificationSettingsForm,
    SlackOrganization
} from "./Model";
import {EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import api from "../util/api";
import {RemoteValue} from "../util/RemoteValue";
import {officeArrayResource} from "./CurrentOfficeStore";
import {SlackSettings_Read} from "../util/access/Permission";

interface SlackSettingsStore extends EntityStore<SlackNotificationSettings[]> {
    createSetting: (form: SlackNotificationSettingsForm) => Promise<SlackNotificationSettings>,
    updateSetting: (setting: SlackNotificationSettings, patch: SlackNotificationSettingsForm) => Promise<SlackNotificationSettings>,
    deleteSetting: (setting: SlackNotificationSettings) => Promise<void>,
    clearState: (setting: SlackNotificationSettings) => Promise<void>,
    sendReport: (setting: SlackNotificationSettings) => Promise<ProgressMessage>,
    organization: RemoteValue<SlackOrganization>,
}

export const useSlackSettingsStore = create<SlackSettingsStore>()(
    officeArrayResource<SlackNotificationSettings, SlackSettingsStore>(EntityType.SlackSettings, builder => {
        const rest = builder.crud<SlackNotificationSettingsForm>('/slack-settings', 'id');

        return {
            remoteValue: builder.all(SlackSettings_Read, () => rest.getAll()),
            createSetting: builder.createAndPatch(rest),
            updateSetting: builder.updateAndPatch(rest),
            deleteSetting: builder.deleteAndPatch(rest),
            clearState: async (setting) => {
                await api.delete(`/offices/${builder.officeId}/slack-settings/${setting.id}/lastReportedProblems`);
            },
            sendReport: async (setting) => {
                const response = await api.post<ProgressMessage>(`/offices/${builder.officeId}/slack-settings/${setting.id}/test`);
                return response.data;
            },
            organization: builder.remoteValue<SlackOrganization>(SlackSettings_Read, async () => {
                try {
                    const axiosResponse = await api.get<SlackOrganization>(`/offices/${builder.officeId}/slack-settings/organization`);
                    return axiosResponse.data;
                } catch (e) {
                    console.error(e);
                    return {
                        id: 'unresolved',
                        name: 'JetBrains',
                        url: 'https://jetbrains.slack.com',
                    };
                }
            }),
        };
    })
);

startEntityStore(useSlackSettingsStore);
